<template>
    <div id="foot-wrapper">
        <div id="foot">
            <div class="copy-right">
                <p>
                    <span><strong>主办单位：</strong>全国各省市区驻京办事处信息协会</span>
                    <span><strong>版权号：</strong>Copyright 2008-2010 全国各省市区驻京办事处信息协会，All rights reserved. 京ICP备13012212号 </span>
                </p>
                <p>
                    <span><strong>地址：</strong>北京丰台区莲花池南路1号燕赵招商中心二楼、北京市朝阳区小红门路222号全国各省市区驻京办事处信息协会</span>
                    <span><strong>电话传真：</strong>010-83364242</span>
                </p>
                <p>
                    <span><strong>邮箱：</strong>zjbxxxh@126.com </span>
                    <span><strong>邮编：</strong>100010</span>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>
#foot-wrapper{
    width:100%;
}
#foot{
    /* background: #fff; */
    /* width:1280px; */
    padding:30px 0 10px;
    margin:0 auto;
    font-family: 思源黑体 CN;
    font-size: 14px;
    text-align: center;
    color: #4E5969;
    border-top: 4px solid #116EBA;
}
#foot p{
    margin-bottom:20px;
}
#foot p span {
    padding-right: 20px;
}
/* .copy-right {
    width:360px;
    display:flex;
    justify-content: space-around;
    align-items: center;
    margin: 0 auto;
    margin-bottom: 5px;
} */
.copy-right img{
    display: block;
    width: 16px;
    height: 17px;
}
</style>